import React, { FC } from 'react';
import CompanyBox from '../components/CompanyBox';

import { ICompany } from '../../types/company';

const LatestCompanies: FC<{
    cssPrefix: string;
    companies?: ICompany[];
    companiesBoxVersion?: number;
    descriptionLimit?: number;
}> = ({ cssPrefix, companies, companiesBoxVersion, descriptionLimit }) => {
    return (
        <section className={`${cssPrefix}-latest-companies`}>
            <div className={`${cssPrefix}-latest-companies-container container`}>
                <h2 className={`${cssPrefix}-latest-companies-header`}>Lista firm dodanych ostatnio</h2>
                <div className={`${cssPrefix}-latest-companies-list`}>
                    {companies &&
                        companies.map((company) => (
                            <React.Fragment key={company.id}>
                                <CompanyBox
                                    cssPrefix={cssPrefix}
                                    company={company}
                                    version={companiesBoxVersion}
                                    descriptionLimit={descriptionLimit}
                                />
                            </React.Fragment>
                        ))}
                </div>
            </div>
        </section>
    );
};

export default LatestCompanies;
